import React from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import PageHeader from 'components/pageHeader';
import StaffRegistrationRequests from 'components/UserDashboardV2/components/StaffRegistrationRequests';
import useResponsive from 'components/UserDashboardV2/hooks/useResponsive';

const StaffRegistrationRequestsPage = () => {
    const history = useHistory();
    const location = useLocation();
    const basePath = location.pathname.startsWith('/user-management-v2') ? '/user-management-v2' : '/user-management';
    const { isMobile } = useResponsive();

    const bodyStyle = {
        margin: -20,
        padding: isMobile ? "20px 12px" : "40px 8px 20px 8px",
        width: "calc(100% + 30px)",
        height: "100vh",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    };

    return (
        <div style={bodyStyle}>
            <PageHeader
                title="Staff registration approval requests"
                onBackPress={() => history.push(`${basePath}/staffs`)}
            />

            <div style={{ margin: "30px 0 0 0", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                <StaffRegistrationRequests isMobile={isMobile} />
            </div>
        </div>
    );
};

export default StaffRegistrationRequestsPage;
